import { get } from "react-hook-form";
import { useAssetDetailsContext } from "../../../../context/assetDetailsContext";
import { getAssetDocuments } from "../../../../repositories/AssetDetailsRepositorie";

type Props = {
	setIsAssetDocumentsLoading: (isLoading: boolean) => void;
	setAssetDocumentsError: (err: string) => void;
};

export const useSearchAssetDocuments = ({
	setIsAssetDocumentsLoading,
	setAssetDocumentsError,
}: Props) => {
	const {
		state: { assetSearchId },
		actions: { setListAssetDocuments },
	} = useAssetDetailsContext();

	return async (includeDescendants = false) => {
		setIsAssetDocumentsLoading(true);
		const res = await getAssetDocuments(assetSearchId, includeDescendants);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			setListAssetDocuments(rowsSource);
			setIsAssetDocumentsLoading(false);
		} else {
			setIsAssetDocumentsLoading(false);
			setAssetDocumentsError(res.message);
		}
	};
};
